import { Router, ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../../api/api.service';

import * as _ from 'lodash';

@Component({
  selector: 'app-edit',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.scss']
})
export class EditComponent implements OnInit {

  model: any = {};
  public locations: any[] = [];
  public destinations: any[] = [];

  constructor(
    private api: ApiService,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.getInventory();
    this.getLocations();
    this.getDestinations();
  }

  getInventory(): void {
    // let id = this.route.snapshot.paramMap.get('id');
    // this.api.inventory.getInventory(id).subscribe(result => {
    //   //console.log(result);

    //   result.createdBy = 'Create By...';
    //   result.statusName = 'FOR POPUP 360';
    //   result.statusComment = 'for 1 min';
    //   this.model = result;

    // });
  }

  getLocations(): void {
    this.api.location.get().subscribe(result => {
      this.locations = result;
    });
  }
  getDestinations(): void {
    this.api.destination.get().subscribe(result => {
      this.destinations = result;
    });
  }

  updateInventory(form) {
    let item = form.value;
    // console.log(item);
    // return false;
    this.api.inventory.update(item).subscribe(result => {
      // console.log(result);
    });
  }

}
